<template>
  <OrganismLoginCallback/>
</template>

<script>
export default {
  name: 'LoginCallback',

  components: {
    OrganismLoginCallback: () => import('@/components/organisms/OrganismLoginCallback')
  },

  mounted () {
    this.$auth.handleAuthentication()
  }
}
</script>
